export const heroData = {
  title: 'Nosotros',
  subtitle:
    'Somos la Sociedad Nacional de Intérpretes y Ejecutantes de la Música (SONIEM), una sociedad de gestión colectiva autorizada por INDECOPI que representa y administra los derechos de los artistas intérpretes y ejecutantes musicales del Perú y del repertorio internacional confiado mediante convenios de representación recíproca.',
  ctaLabel: 'Conoce nuestra historia',
};

export const timelineEvents = [
  {
    year: '2011',
    title: 'Fundación de SONIEM',
    description:
      'El 22 de julio de 2011, un grupo de artistas intérpretes y ejecutantes musicales constituye SONIEM con la finalidad de gestionar colectivamente sus derechos.',
    imageSeq: 'nosotros-timeline-01',
  },
  {
    year: '2011',
    title: 'Autorización por INDECOPI',
    description:
      'Mediante Resolución N.º 0054-2011/DDA-INDECOPI, el Estado peruano autoriza el funcionamiento de SONIEM como sociedad de gestión colectiva.',
    imageSeq: 'nosotros-timeline-02',
  },
  {
    year: '2012',
    title: 'Inicio de la gestión colectiva',
    description:
      'SONIEM inicia la administración de los derechos de sus primeros afiliados, sentando las bases del sistema de recaudación y distribución.',
    imageSeq: 'nosotros-timeline-03',
  },
  {
    year: '2014',
    title: 'Primeros convenios internacionales',
    description:
      'Se firman los primeros convenios de representación recíproca con sociedades de gestión de América Latina, integrando a SONIEM en la red internacional.',
    imageSeq: 'nosotros-timeline-04',
  },
  {
    year: '2018',
    title: 'Fortalecimiento institucional',
    description:
      'Consolidación de la estructura organizativa, ampliación de la base de afiliados y modernización de los sistemas de identificación y distribución.',
    imageSeq: 'nosotros-timeline-05',
  },
  {
    year: '2025',
    title: 'Actualidad',
    description:
      'SONIEM representa a más de 3,300 artistas musicales y continúa expandiendo su red de convenios internacionales, consolidándose como referente en la gestión colectiva del Perú.',
    imageSeq: 'nosotros-timeline-06',
  },
];

export const misionData = {
  title: 'Nuestra Misión',
  description:
    'Proteger, administrar y recaudar las remuneraciones que corresponden a los artistas intérpretes y ejecutantes musicales por la comunicación pública de sus interpretaciones y ejecuciones fijadas en fonogramas y obras audiovisuales, garantizando una gestión colectiva transparente, democrática y eficiente, en beneficio del desarrollo cultural del Perú.',
};

export const visionData = {
  title: 'Nuestra Visión',
  description:
    'Consolidarnos como la sociedad de gestión colectiva más confiable y representativa del Perú, reconocida nacional e internacionalmente por la excelencia en la administración de los derechos de los artistas musicales, la transparencia institucional y el compromiso con el fortalecimiento de la cultura musical peruana.',
};

export const valoresData = [
  {
    icon: 'ri-shield-check-line',
    title: 'Transparencia',
    description: 'Actuamos con apertura y rendición de cuentas en cada uno de nuestros procesos, garantizando la confianza de nuestros afiliados.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Compromiso con los artistas',
    description: 'Trabajamos para proteger y promover los derechos de los artistas intérpretes y ejecutantes musicales del Perú.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Ética',
    description: 'Nuestra actuación se rige por principios de integridad, honestidad y responsabilidad en todas nuestras decisiones.',
  },
  {
    icon: 'ri-global-line',
    title: 'Cooperación internacional',
    description: 'Fomentamos la colaboración con sociedades de gestión de todo el mundo para ampliar la protección de nuestros afiliados.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Innovación',
    description: 'Incorporamos tecnología y procesos modernos para optimizar la identificación, recaudación y distribución de derechos.',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Desarrollo cultural',
    description: 'Contribuimos al fortalecimiento de la cultura musical peruana mediante la protección efectiva de los derechos de sus creadores.',
  },
];

export const gobernanzaData = {
  title: 'Una institución democrática al servicio de los artistas',
  description:
    'SONIEM desarrolla su gestión bajo un modelo de gobierno democrático y participativo, garantizando la representación de los artistas, la transparencia institucional y el cumplimiento del marco legal aplicable.',
};

export const asambleaData = {
  title: 'Asamblea General',
  description:
    'La Asamblea General constituye el máximo órgano de gobierno de SONIEM. Está integrada por todos los artistas afiliados que se encuentran al día en sus obligaciones conforme al Estatuto. Es el espacio democrático donde se elige al Consejo Directivo, se aprueban los estados financieros y se definen las políticas institucionales que guían la gestión colectiva.',
};

export const consejoDirectivoData = {
  title: 'Consejo Directivo',
  subtitle: 'Gestión 2022 – 2027',
  president: {
    name: 'Julie Anna Freundt López',
    role: 'Presidenta',
    bio: 'Cantante, compositora y productora musical peruana con una destacada trayectoria artística y una amplia participación en el desarrollo de la industria musical. Como Presidenta del Consejo Directivo de SONIEM (2022–2027), lidera el fortalecimiento institucional de la sociedad, impulsa la modernización de la gestión colectiva y promueve la defensa de los derechos de los artistas intérpretes y ejecutantes musicales tanto en el ámbito nacional como internacional.',
    imageSeq: 'nosotros-presidenta',
    linkedinUrl: 'https://www.linkedin.com/in/julie-freundt-28645a97/',
  },
  members: [
    {
      name: 'Fernando Enrique Rentería Balado',
      role: 'Secretario Ejecutivo',
      bio: 'Artista intérprete y ejecutante musical e integrante del Consejo Directivo de SONIEM. Desde la Secretaría Ejecutiva participa en la coordinación institucional y en la ejecución de los acuerdos adoptados por los órganos de gobierno, contribuyendo al fortalecimiento de la representación de los artistas afiliados.',
    },
    {
      name: 'Óscar Vicente Cavero Aróstegui',
      role: 'Secretario de Asuntos Socioculturales',
      bio: 'Reconocido músico, ejecutante y productor musical peruano. Integra el Consejo Directivo de SONIEM promoviendo iniciativas relacionadas con el desarrollo cultural, la difusión de la música peruana y el fortalecimiento del sector artístico.',
    },
    {
      name: 'Ruth Karina Armas Ríos',
      role: 'Primera Vocal',
      bio: 'Cantante y artista intérprete peruana. Participa en la definición de políticas institucionales y en las acciones destinadas a fortalecer la protección de los derechos de los artistas musicales representados por SONIEM.',
    },
    {
      name: 'John Edgar Rojas Bernaza',
      role: 'Segundo Vocal',
      bio: 'Artista intérprete y ejecutante musical. Forma parte del Consejo Directivo participando en el fortalecimiento institucional y en las acciones orientadas a consolidar la gestión colectiva de los derechos de los artistas musicales.',
    },
  ],
};

export const direccionGeneralData = {
  name: 'Maritza Isabel Rojas Portal',
  role: 'Directora General',
  bio: 'Abogada con amplia experiencia en Derecho Civil, Corporativo, Administrativo, Constitucional y Propiedad Intelectual. Cuenta con estudios de especialización en gestión colectiva y forma parte del Comité Jurídico y Técnico de FILAIE. Como Directora General de SONIEM dirige la gestión ejecutiva de la institución, liderando la implementación de las políticas aprobadas por los órganos de gobierno, la modernización institucional, el fortalecimiento de los servicios dirigidos a los artistas afiliados y el desarrollo de nuevos modelos de gestión colectiva, incluyendo la gestión de los derechos de las interpretaciones y ejecuciones musicales fijadas o incorporadas en obras audiovisuales.',
  funciones: [
    'Ejecutar los acuerdos de la Asamblea General y del Consejo Directivo',
    'Dirigir la gestión administrativa, técnica y operativa de la sociedad',
    'Representar legalmente a SONIEM ante entidades públicas y privadas',
    'Supervisar los procesos de recaudación, identificación y distribución',
    'Proponer al Consejo Directivo planes estratégicos y operativos',
  ],
  imageSeq: 'nosotros-directora-general',
};

export const comiteVigilanciaData = {
  title: 'Comité de Vigilancia',
  description:
    'El Comité de Vigilancia es el órgano encargado de supervisar la gestión institucional de SONIEM, velando por el cumplimiento del Estatuto, la transparencia administrativa y la adecuada protección de los intereses de los artistas afiliados.',
  members: [
    {
      name: 'Luciano Augusto Díaz Límaco',
      role: 'Presidente',
      bio: 'Artista intérprete y ejecutante musical. Preside el Comité de Vigilancia, órgano responsable de supervisar la gestión institucional y promover las buenas prácticas de gobierno y transparencia dentro de SONIEM.',
    },
    {
      name: 'José Francisco Meza Muñoz',
      role: 'Secretario',
      bio: 'Integra el Comité de Vigilancia y participa en las labores de seguimiento y supervisión de la gestión institucional en representación de los afiliados.',
    },
    {
      name: 'Rodolfo Barriga Montagne',
      role: 'Vocal',
      bio: 'Miembro del Comité de Vigilancia. Participa en las acciones de supervisión institucional previstas en el Estatuto de SONIEM, contribuyendo al fortalecimiento de la transparencia y el control interno.',
    },
  ],
};

export const comiteElectoralData = {
  title: 'Comité Electoral',
  description:
    'El Comité Electoral es el órgano autónomo que garantiza la transparencia, imparcialidad y legalidad de los procesos electorales internos de SONIEM. Su función es organizar, conducir y supervisar las elecciones de los miembros del Consejo Directivo y del Comité de Vigilancia, asegurando la participación democrática de todos los afiliados.',
  members: [
    {
      name: 'Miguel Ángel Suárez Romero',
      role: 'Presidente del Comité Electoral',
    },
    {
      name: 'Gloria Estela Ramírez Campos',
      role: 'Miembro',
    },
    {
      name: 'Pedro Antonio Valdivia Herrera',
      role: 'Miembro',
    },
  ],
};

export const transparenciaData = {
  title: 'Transparencia y Control',
  gobernanza: {
    title: 'Gobernanza',
    description:
      'Modelo democrático con participación activa de los afiliados a través de sus órganos de gobierno: Asamblea General, Consejo Directivo, Comité de Vigilancia y Comité Electoral.',
  },
  supervision: {
    title: 'Supervisión Pública',
    description:
      'El Instituto Nacional de Defensa de la Competencia y de la Protección de la Propiedad Intelectual (INDECOPI) autoriza el funcionamiento de SONIEM, supervisa su gestión, fiscaliza el cumplimiento de la legislación aplicable y contribuye a garantizar la transparencia del sistema de gestión colectiva en el Perú.',
  },
  auditoria: {
    title: 'Auditoría Externa',
    description:
      'SONIEM somete anualmente su gestión económica y financiera a una auditoría externa independiente, fortaleciendo la transparencia institucional y la confianza de sus afiliados.',
  },
  codigoEtica: {
    title: 'Código de Ética',
    description:
      'La actuación institucional y de todos los miembros de los órganos de gobierno de SONIEM se desarrolla conforme a principios de integridad, transparencia y responsabilidad, establecidos en el Código de Ética.',
    ctaLabel: 'Ver Código de Ética',
  },
};

export const marcoNormativoData = {
  title: 'Marco Normativo',
  documentos: [
    {
      id: 'estatuto',
      nombre: 'Estatuto',
      descripcion:
        'Documento fundamental que establece la naturaleza jurídica, estructura orgánica, derechos y obligaciones de los afiliados de SONIEM.',
    },
    {
      id: 'reglamento-general',
      nombre: 'Reglamento General',
      descripcion:
        'Norma que desarrolla y complementa las disposiciones del Estatuto para la operación cotidiana de la sociedad.',
    },
    {
      id: 'reglamento-electoral',
      nombre: 'Reglamento Electoral',
      descripcion:
        'Regula los procesos de elección de los miembros del Consejo Directivo y del Comité de Vigilancia, garantizando su transparencia y legalidad.',
    },
    {
      id: 'codigo-etica',
      nombre: 'Código de Ética',
      descripcion:
        'Conjunto de principios y normas que rigen la conducta de los directivos, funcionarios y colaboradores de SONIEM.',
    },
    {
      id: 'dl-822',
      nombre: 'Decreto Legislativo N.º 822',
      descripcion:
        'Ley sobre el Derecho de Autor que regula la protección de los derechos de los creadores, artistas intérpretes y ejecutantes en el Perú.',
    },
    {
      id: 'ley-28131',
      nombre: 'Ley N.º 28131 - Ley del Artista',
      descripcion:
        'Ley del Artista Intérprete y Ejecutante que reconoce y protege los derechos laborales y de propiedad intelectual de los artistas en el Perú.',
    },
    {
      id: 'decision-351',
      nombre: 'Decisión 351 de la Comunidad Andina',
      descripcion:
        'Régimen común sobre derecho de autor y derechos conexos aplicable en Bolivia, Colombia, Ecuador y Perú.',
    },
    {
      id: 'dl-1391',
      nombre: 'Decreto Legislativo N.º 1391',
      descripcion:
        'Norma que modifica y fortalece el marco legal del derecho de autor y los derechos conexos en el Perú.',
    },
    {
      id: 'resolucion-autorizacion',
      nombre: 'Resolución de autorización de funcionamiento',
      descripcion:
        'Resolución N.º 0054-2011/DDA-INDECOPI mediante la cual el Estado peruano autoriza el funcionamiento de SONIEM como sociedad de gestión colectiva.',
    },
    {
      id: 'otros',
      nombre: 'Otros documentos institucionales',
      descripcion:
        'Normativa complementaria, directivas internas y disposiciones administrativas que rigen el funcionamiento de SONIEM.',
    },
  ],
};

export const representacionData = {
  title: 'Representación Internacional',
  subtitle: 'Una red internacional al servicio de los artistas musicales',
  description:
    'SONIEM forma parte de una red internacional de sociedades de gestión colectiva que permite representar en el Perú los derechos de miles de artistas intérpretes y ejecutantes musicales extranjeros y, al mismo tiempo, extender la representación de sus artistas afiliados en otros países mediante convenios de representación recíproca.',
  sociedades: [
    {
      nombre: 'FILAIE',
      descripcion: 'Federación Internacional de Sociedades de Artistas, Intérpretes y Ejecutantes',
    },
    {
      nombre: 'AISGE',
      descripcion: 'Artistas Intérpretes, Sociedad de Gestión — España',
    },
    {
      nombre: 'SAGAI',
      descripcion: 'Sociedad Argentina de Gestión de Actores Intérpretes — Argentina',
    },
    {
      nombre: 'ABRAMUS',
      descripcion: 'Asociación Brasileña de Música y Artes — Brasil',
    },
    {
      nombre: 'SCD',
      descripcion: 'Sociedad Chilena de Autores e Intérpretes Musicales — Chile',
    },
    {
      nombre: 'EGEDA',
      descripcion: 'Entidad de Gestión de Derechos de Productores Audiovisuales',
    },
    {
      nombre: 'AIE',
      descripcion: 'Artistas Intérpretes y Ejecutantes — España',
    },
    {
      nombre: 'ANDI',
      descripcion: 'Asociación Nacional de Intérpretes — México',
    },
  ],
  paisesDestacados: [
    'Perú', 'Argentina', 'Brasil', 'Chile', 'Colombia', 'Ecuador',
    'México', 'España', 'Estados Unidos', 'Francia', 'Italia', 'Portugal',
  ],
};

export const compromisoData = {
  title: 'Nuestro compromiso',
  description:
    'Trabajamos para representar, proteger y administrar los derechos de los artistas intérpretes y ejecutantes musicales mediante una gestión colectiva transparente, democrática y eficiente, fortaleciendo el desarrollo de la música peruana y su proyección nacional e internacional.',
  ctaLabel: 'Conoce los derechos que representamos',
  ctaHref: '/derechos',
};